import React, { useState } from "react";
import { SECTIONS } from "../../../assets/MockData/mockData";
import { ReactComponent as COLLAPSE_IMG } from "../../../assets/images/Frame (34).svg";
import MyPopover from "../../Common/Popover/MyPopover";

const SideBarClosed = ({
  toggleSideBar,
  isAuthenticated = false,
  onGuestMenuClick,
  onOptionSelect,
  isOptionVisible = (option) => !option.launchVendor,
}) => {
  const [sections] = useState(SECTIONS);

  return (
    <div
      className="closed-sidebar-content"
      onClickCapture={(event) => {
        const isSidebarToggle = event.target
          ?.closest?.("[data-sidebar-toggle-control]");

        if (!isAuthenticated && !isSidebarToggle) {
          onGuestMenuClick?.(event, "collapsed-sidebar-menu");
        }
      }}
    >
      <div data-sidebar-toggle-control>
        <MyPopover
          icon={<COLLAPSE_IMG style={{ width: "25px", height: "25px" }} />}
          position="left"
          title="메뉴 열기"
          onClick={() => toggleSideBar(true)}
        />
      </div>

      {sections.map((section, sectionIndex) =>
        section.options.map((option, optionIndex) => {
          if (!isAuthenticated && option.externalType === "telegram") return null;
          if (!isOptionVisible(option)) return null;

          return (
            <MyPopover
              key={`${section.name}-${option.text}-${optionIndex}`}
              parentOption={option}
              subOptions={option?.dropdownOptions}
              position="left"
              onClick={(event) =>
                onOptionSelect?.(sectionIndex, optionIndex, option, event)
              }
            />
          );
        })
      )}
    </div>
  );
};

export default SideBarClosed;
